'use strict';

var urlsVVS = {
  // api: 'http://localhost:8080/woe18/api/stock/'
  // api: 'http://192.168.100.23:8085/woe18/api/stock/'
  // api: 'https://ofertas.nissan.es/api/stock/'
  // api: 'https://ofertas.nissan.es/ws/api/webstock/'
  api: 'https://ofertas.nissan.es/stock/api/'
  // console.log('urlsVVS', urlsVVS)

};